import { Text } from '@/components/ui/text'
import {
  type Component,
  createEffect,
  createSignal,
  on,
  onCleanup
} from 'solid-js'
import { Motion } from 'solid-motionone'
import { circle } from 'styled-system/patterns'

export const UnreadCount: Component<{ count: number }> = (props) => {
  const [isPulsing, setIsPulsing] = createSignal(false)

  // Trigger the pulse effect whenever the count changes
  createEffect(
    on(
      () => props.count,
      (newCount, oldCount) => {
        if (newCount !== oldCount) {
          setIsPulsing(true)

          const timer = setTimeout(() => setIsPulsing(false), 200)
          onCleanup(() => clearTimeout(timer))
        }
      },
      { defer: true }
    )
  )

  const displayCount = () => (props.count > 99 ? '99+' : props.count)

  return (
    <Motion.div
      initial={false} // Prevents the animation from firing on initial mount
      animate={{
        scale: isPulsing() ? 1.2 : 1
      }}
      transition={{
        duration: 0.3,
        easing: [0.19, 1, 0.22, 1] // Using your custom easing curve
      }}
      class={circle({
        background: 'red.a6',
        h: 5,
        minW: 5,
        px: props.count > 9 ? 1 : 0,
      })}
      title={String(props.count)}
      data-unread={props.count}
    >
      <Text fontSize="10px" color="fg">
        {displayCount()}
      </Text>
    </Motion.div>
  )
}
